import React from 'react';
import './home.css'

function Home() {
  return (
    <div className="home">
      <h5>OK</h5>
    </div>
  );
}

export default Home;